import { Component, EventEmitter, AfterViewInit, Input, OnInit, Output, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from 'src/app/provider/config.service';
import { Subscription, Subject } from 'rxjs';

@Component({
  selector: 'menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  standalone: false,
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() item: any;
  @Input() isForceFixedMenu: boolean = false;
  @Input() mealsCount: number = 0;
  @Input() snacksCount: number = 0;
  @Input() is_variable_carbs: boolean = false;
  @Input() max_scaled_carbs: number = 100;
  @Input() dayConfigEntry: any;
  @Input() defaultCarbs: number | null = null;

  @Output() quantityChangeRequest = new EventEmitter<{ itemId: number; isPlusClick: boolean }>();
  @Output() itemSelectionChanged = new EventEmitter<any>();
  @Output() menuDetailRequested = new EventEmitter<any>();
  @Output() carbSelectionChanged = new EventEmitter<any>();

  appL: string = 'en';
  public settings: any;
  private appSettingsSubscription: Subscription;

  selectionLimit: { [key: string]: number } = {};
  private destroy$ = new Subject<void>();
  isMeal: boolean;
  limit: any;

  constructor(private translate: TranslateService, private configService: ConfigService, private cdRef: ChangeDetectorRef) {}

  async ngOnInit() {
    this.appSettingsSubscription = this.configService.appSettings$.subscribe((currentSettings) => {
      this.settings = currentSettings;
      this.translate.setDefaultLang(this.settings.appLanguage);
      this.translate.use(this.settings.appLanguage);
      this.appL = this.settings.appLanguage;
      this.cdRef.markForCheck();
    });
    this.isMeal = this.item?.food_type_category == 'meal' ? true : false;
    this.limit = this.isMeal ? this.mealsCount : this.snacksCount;
    // console.log(this.isMeal, this.item.food_type_category.toUpperCase(), this.limit, this.item.quantity);
  }

  ngAfterViewInit() {
    // Nothing extra needed for OnPush
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.appSettingsSubscription) this.appSettingsSubscription.unsubscribe();
  }

  // ✅ Toggle selection
  onSelectFoodMenu() {
    if (!this.item) return;

    if (this.item.quantity === 0) {
      this.onPlusClick();
    } else if (this.item.quantity == this.limit) {
      return;
    } else {
      this.onMinusClick();
    }
  }

  // ✅ Plus / Minus clicks emit event to parent
  onMinusClick() {
    if (!this.item || this.item.quantity === 0) {
      return;
    }
    this.quantityChangeRequest.emit({ itemId: this.item.id, isPlusClick: false });
  }

  onPlusClick() {
    if (!this.item || this.item.quantity == this.limit) {
      return;
    }
    this.quantityChangeRequest.emit({ itemId: this.item.id, isPlusClick: true });
  }

  onMenuDetailPage() {
    this.menuDetailRequested.emit({item: this.item});
  }

  // Shorten title/description for display
  getShortTitle = (data: string): string => {
    if (!data) return '';
    return data.length > 39 ? data.substring(0, 39) + '...' : data;
  };

  getShortDesc = (data: string): string => {
    if (!data) return '';
    return data.length > 49 ? data.substring(0, 49) + '...' : data;
  };

  getParseFloat = (num: any): number => Number(parseFloat(num).toFixed(0));
}
